import { FormControlLabel, Switch } from '@mui/material'

import * as React from 'react'

interface IIsActiveToggleProps {
  disabled?: boolean
  isActive: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}

const IsActiveToggle: React.FC<IIsActiveToggleProps> = ({
  disabled,
  isActive,
  onChange,
}) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={isActive}
          disabled={disabled}
          onChange={onChange}
          value="isActive"
          color="secondary"
          name="isActive"
        />
      }
      label={isActive ? 'Active' : 'Inactive'}
    />
  )
}

export default IsActiveToggle
